import {Component, EventEmitter, Injector, Input, Output, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../ui/components/base/base.component";

@Component({
  selector: "password-input",
  templateUrl: './passaword.input.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PassawordInputComponent extends BaseComponent {

  passwordMode: string = "password";

  @Input()
  value: string;

  @Output()
  valueChange:EventEmitter<string> = new EventEmitter<string>();

  passwordButtonOptions = {
    icon: this.passwordMode === "password" ? "fa fa-eye-slash" : "fa fa-eye", //
    type: "default",
    stylingMode: "text",
    onClick: () => {
      // Alterna o modo e o �cone
      this.passwordMode = this.passwordMode === "password" ? "text" : "password";
      this.passwordButtonOptions = {
        ...this.passwordButtonOptions,
        icon: this.passwordMode === "password" ? "fa fa-eye-slash" : "fa fa-eye"
      };
    }
  };

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

  passwordChange(event: string){
    this.valueChange.emit(event);
  }
}
